import styled from 'styled-components'
// themes
import { colors } from 'themes/index'

export const Section = styled.div`
  border-top: 1px solid ${colors.gray290};
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding-top: 16px;
`

export const Header = styled.div`
  background-color: ${colors.white100};
  margin-top: -4px;
  padding-bottom: 8px;
  padding-top: 4px;
  position: sticky;
  top: 0;
  z-index: 1;
`

export const Title = styled.div`
  font-size: 16px;
  font-weight: 500;
`

export const LabelWrapper = styled.div`
  display: flex;
  color: ${colors.gray400};
  margin-bottom: -12px;
  margin-left: 2px;
  font-size: 14px;

  div:nth-child(1) {
    flex: 1;
  }

  div:nth-child(2) {
    flex: 0.6;
  }
`

export const ActionsWrapper = styled.div`
  display: flex;
  justify-content: space-between;

  > :last-child {
    margin-left: auto;
  }
`
